// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"bXqsU":[function(require,module,exports) {
require("db1efbaef5dec38e").register(require("ba52b7835d1ff338").getBundleURL("hYyS2"), JSON.parse('["hYyS2","mealPlanner.fe591069.js","6pYmK","../icons.7bb96926.svg","4vDYv","../index.1b5fdb01.js","9Pxhc","../index.cd8c9dd4.js"]'));

},{"db1efbaef5dec38e":"44XlC","ba52b7835d1ff338":"7Ve2W"}],"44XlC":[function(require,module,exports) {
"use strict";
var mapping = new Map();
function register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function resolve(id) {
    var resolved = mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
module.exports.register = register;
module.exports.resolve = resolve;

},{}],"7Ve2W":[function(require,module,exports) {
"use strict";
var bundleURL = {};
function getBundleURLCached(id) {
    var value = bundleURL[id];
    if (!value) {
        value = getBundleURL();
        bundleURL[id] = value;
    }
    return value;
}
function getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return getBaseURL(matches[2]);
    }
    return "/";
}
function getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
exports.getBundleURL = getBundleURLCached;
exports.getBaseURL = getBaseURL;
exports.getOrigin = getOrigin;

},{}],"eYRlG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _webImmediateJs = require("core-js/modules/web.immediate.js");
var _modelJs = require("./model.js");
var _recipeViewJs = require("./views/recipeView.js");
var _recipeViewJsDefault = parcelHelpers.interopDefault(_recipeViewJs);
var _plannerViewJs = require("./views/plannerView.js");
var _plannerViewJsDefault = parcelHelpers.interopDefault(_plannerViewJs);
var _plannerPaginationViewJs = require("./views/plannerPaginationView.js");
var _plannerPaginationViewJsDefault = parcelHelpers.interopDefault(_plannerPaginationViewJs);
var _timeViewJs = require("./views/timeView.js");
var _timeViewJsDefault = parcelHelpers.interopDefault(_timeViewJs);
var _themeViewJs = require("./views/themeView.js");
var _themeViewJsDefault = parcelHelpers.interopDefault(_themeViewJs);
var _runtime = require("regenerator-runtime/runtime");
const controlRecipesPlanner = async function() {
    try {
        const id = window.location.hash.slice(1);
        if (!id) return;
        (0, _recipeViewJsDefault.default).scrollToRecipe();
        (0, _recipeViewJsDefault.default).renderSpinner();
        // 1) Update results view to mark selected search result
        (0, _plannerViewJsDefault.default).render(_modelJs.state.planner);
        // 2) Loading recipe
        await _modelJs.loadRecipe(id);
        // 3) Rendering recipe
        (0, _recipeViewJsDefault.default).render(_modelJs.state.recipe);
    } catch (err) {
        console.error(`${err.message} \u{26A0}\u{26A0}\u{26A0}`);
        (0, _recipeViewJsDefault.default).renderError();
    }
    // rendering the recipe without the nutritional data
    if (!_modelJs.state.recipe.calories) (0, _recipeViewJsDefault.default).render(_modelJs.state.recipe);
};
const controlServings = function(newServings) {
    _modelJs.updateServings(newServings);
    (0, _recipeViewJsDefault.default).update(_modelJs.state.recipe);
};
const controlAddToShoppingList = function(ingredient) {
    _modelJs.addIngredient(ingredient);
};
const controlPlannerUI = function() {
    _modelJs.changeActive(0);
    (0, _plannerViewJsDefault.default).render(_modelJs.state.planner);
};
const controlResetPlanner = function() {
    _modelJs.clearPlanner();
    (0, _plannerViewJsDefault.default).render(_modelJs.state.planner);
};
const controlDeletePlanned = function(day, meal) {
    _modelJs.deleteMeal(day, meal);
    (0, _plannerViewJsDefault.default).clearCell(day, meal);
};
const controlRenderBtns = function() {
    _modelJs.changeWeek(1);
    (0, _plannerPaginationViewJsDefault.default).render(_modelJs.state.planner);
    (0, _plannerViewJsDefault.default).render(_modelJs.state.planner);
};
const controlChangeWeek = function(goToWeek = 1) {
    _modelJs.changeWeek(goToWeek);
    (0, _plannerPaginationViewJsDefault.default).render(_modelJs.state.planner);
    (0, _plannerViewJsDefault.default).render(_modelJs.state.planner);
};
const controlDate = function() {
    (0, _timeViewJsDefault.default).render(_modelJs.state.planner);
};
const controlActiveDay = function(active) {
    _modelJs.changeActive(active);
    (0, _plannerViewJsDefault.default).render(_modelJs.state.planner);
};
const controlTheme = function(actualTheme) {
    let newTheme = "light";
    if (actualTheme === "light") newTheme = "dark";
    _modelJs.changeTheme(newTheme);
    (0, _themeViewJsDefault.default).setTheme(newTheme);
};
const initTheme = function() {
    (0, _themeViewJsDefault.default).setTheme(_modelJs.state.theme);
};
const init = function() {
    (0, _recipeViewJsDefault.default).addHandlerRender(controlRecipesPlanner);
    (0, _recipeViewJsDefault.default).addHandlerUpdateServings(controlServings);
    (0, _recipeViewJsDefault.default).addHandlerAddIngredient(controlAddToShoppingList);
    (0, _plannerViewJsDefault.default).addHandlerLoadPlanner(controlPlannerUI);
    (0, _plannerViewJsDefault.default).addHandlerResetPlanner(controlResetPlanner);
    (0, _plannerViewJsDefault.default).addHandlerDeletePlanned(controlDeletePlanned);
    (0, _plannerViewJsDefault.default).addHandlerSubmitWeekday(controlActiveDay);
    (0, _plannerViewJsDefault.default).addHandlerDetectChange();
    (0, _plannerPaginationViewJsDefault.default).addHandlerRenderBtns(controlRenderBtns);
    (0, _plannerPaginationViewJsDefault.default).addHandlerChangeWeek(controlChangeWeek);
    (0, _timeViewJsDefault.default).addHandlerRenderDate(controlDate);
    (0, _themeViewJsDefault.default).addHandlerChangeTheme(controlTheme);
    initTheme();
};
init();

},{"core-js/modules/web.immediate.js":"b7Fhu","./model.js":"5XrL7","./views/recipeView.js":"gcMxR","./views/plannerView.js":"9QyyT","./views/plannerPaginationView.js":"a9BvE","./views/timeView.js":"hGnu3","./views/themeView.js":"htPRE","regenerator-runtime/runtime":"j1Ujo","@parcel/transformer-js/src/esmodule-helpers.js":"83weF"}],"9QyyT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _iconsSvg = require("url:../../img/icons.svg");
var _iconsSvgDefault = parcelHelpers.interopDefault(_iconsSvg);
var _view = require("./View");
var _viewDefault = parcelHelpers.interopDefault(_view);
var _helpersJs = require("../helpers.js");
class PlannerView extends (0, _viewDefault.default) {
    _parentElement = document.querySelector(".planner__grid");
    addHandlerLoadPlanner(handler) {
        window.addEventListener("load", handler);
    }
    addHandlerResetPlanner(handler) {
        document.querySelector(".page-options__btn--reset-calendar").addEventListener("click", handler);
    }
    addHandlerDeletePlanned(handler) {
        this._parentElement.addEventListener("click", function(e) {
            const btn = e.target.closest(".planned__remove-btn");
            if (!btn) return;
            const day = btn.closest(".planned").dataset.positionI;
            const meal = btn.closest(".planned").dataset.positionJ;
            // console.log(day, meal);
            handler(day, meal);
        });
    }
    addHandlerDetectChange() {
        this._parentElement.closest(".section__planner").querySelector(".planner__form").addEventListener("input", function(e) {
            this.querySelector(".planner__submit").click();
        });
    }
    addHandlerSubmitWeekday(handler) {
        this._parentElement.closest(".section__planner").querySelector(".planner__form").addEventListener("submit", function(e) {
            console.log("triggered");
            e.preventDefault();
            const active = +this.querySelector("#weekday").value;
            console.log(active);
            handler(active);
        });
    }
    clearCell(i, j) {
        Array.from(this._parentElement.getElementsByClassName(`planned`)).find((el)=>el.dataset.positionI === i && el.dataset.positionJ === j).innerHTML = "";
    }
    _generateMarkup() {
        const active = this._data.active;
        return this._data[this._data.page === 1 ? "currentWeek" : "nextWeek"].map((day, i)=>day.map((meal, j)=>this._generatePlannerCell(i, j, meal, active)).join("")).join("");
    }
    _generatePlannerCell(i, j, meal, active) {
        const id = window.location.hash;
        return `
      <div class="planner__recipe planner__recipe--${i + 1}${j + 1} planned ${i === active ? "planner__recipe--active" : ""}" data-position-i="${i}" data-position-j="${j}">
        ${!meal ? "" : `
        <a class="planned__link ${id === meal.id ? "planned__link--active" : ""}" href="${meal.id}">
            <figure class="planned__fig">
                <img src="${meal.img}" alt="${meal.title}" />
            </figure>
            <h4 class="planned__title">${(0, _helpersJs.maxFourWords)(meal.title)}</h4>
            
        </a>
        <div class="planned__remove-btn" data-id=${meal.id}>
              <svg>
                <use href="${0, _iconsSvgDefault.default}#icon-bin"></use>
              </svg>
        </div>
        `}   
      </div>
      `;
    }
}
exports.default = new PlannerView();

},{"url:../../img/icons.svg":"7r4e3","./View":"lslfl","../helpers.js":"rOFoc","@parcel/transformer-js/src/esmodule-helpers.js":"83weF"}],"7r4e3":[function(require,module,exports) {
module.exports = require("d29cc0e2dee6fa56").getBundleURL("hYyS2") + "../icons.7bb96926.svg";

},{"d29cc0e2dee6fa56":"7Ve2W"}],"a9BvE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _iconsSvg = require("url:../../img/icons.svg");
var _iconsSvgDefault = parcelHelpers.interopDefault(_iconsSvg);
var _model = require("../model");
var _view = require("./View");
var _viewDefault = parcelHelpers.interopDefault(_view);
class PlannerPaginationView extends (0, _viewDefault.default) {
    _parentElement = document.querySelector(".planner__pagination");
    addHandlerRenderBtns(handler) {
        window.addEventListener("load", handler);
    }
    addHandlerChangeWeek(handler) {
        this._parentElement.addEventListener("click", function(e) {
            const btn = e.target.closest(".btn--week");
            if (!btn) return;
            const goToWeek = +btn.dataset.goToWeek;
            handler(goToWeek);
        });
    }
    _generateMarkup() {
        const currentPage = this._data.page;
        if (currentPage === 1) return `
      <button class="btn--week pagination__btn--next" data-go-to-week="${currentPage + 1}">
        <span>Next week</span>
        <svg class="search__icon">
          <use href="${0, _iconsSvgDefault.default}#icon-arrow-right"></use>
        </svg>
      </button>
      `;
        if (currentPage === 2) return `
      <button class="btn--week pagination__btn--prev" data-go-to-week="${currentPage - 1}">
        <svg class="search__icon">
          <use href="${0, _iconsSvgDefault.default}#icon-arrow-left"></use>
        </svg>
        <span>Current week</span>
      </button>
      `;
    }
}
exports.default = new PlannerPaginationView();

},{"url:../../img/icons.svg":"7r4e3","../model":"5XrL7","./View":"lslfl","@parcel/transformer-js/src/esmodule-helpers.js":"83weF"}],"hGnu3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _view = require("./View");
var _viewDefault = parcelHelpers.interopDefault(_view);
var _helpersJs = require("../helpers.js");
class TimeView extends (0, _viewDefault.default) {
    _parentElement = document.querySelector(".planner__date");
    addHandlerRenderDate(handler) {
        window.addEventListener("load", handler);
    }
    _generateMarkup() {
        return `
    <div class="planner__date-label">
        <div class="planner__date-text">${(0, _helpersJs.formatDate)()}</div>
    </div>
    `;
    }
}
exports.default = new TimeView();

},{"./View":"lslfl","../helpers.js":"rOFoc","@parcel/transformer-js/src/esmodule-helpers.js":"83weF"}]},["bXqsU","eYRlG"], "eYRlG", "parcelRequire3a11")

//# sourceMappingURL=mealPlanner.fe591069.js.map
